import Subcategory from "./Subcategory";

export default Subcategory;
